import React, { useState } from 'react';
import moment from 'moment';
import Icon from '@/common/components/Icon';
import { TodoItem, TodoItemElement } from './TodoListItem.styled';
import { Colors } from '@/common/colors/colors';
import { createPortal } from 'react-dom';
import TodoPreview from '@/common/components/todoPreview/TodoPreview';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import { TODO_STATUSES } from '@/common/constants/todoStatuses';

const TodoListItem = ({
	todo,
	handleEditTodo,
	updateStatus,
	loadingTodoId,
	loadData,
	status,
	notRead,
}) => {
	const [isTodoPreviewOpen, setIsTodoPreviewOpen] = useState();
	return (
		<TodoItem
			backgroundColor={
				todo.high_priority ? Colors.lightBlue2 : Colors.lightlightBlue2
			}
		>
			{loadingTodoId === todo._id ? (
				<CustomSkeleton height={10} count={3} width='800px' />
			) : (
				<>
					<TodoItemElement>
						{notRead.includes(todo._id) && (
							<Icon name='readme' color={Colors.red} />
						)}{' '}
						{todo.title}
					</TodoItemElement>
					<TodoItemElement>{todo._user.username}</TodoItemElement>
					<TodoItemElement>
						{moment(todo.deadline).format('YYYY-MM-DD HH:mm')}
					</TodoItemElement>
					<TodoItemElement>
						{todo.status !== TODO_STATUSES.DONE.value && (
							<Icon
								size={20}
								name='edit'
								onClick={() => handleEditTodo(todo)}
							/>
						)}
						{TODO_STATUSES[status]?.previous && (
							<Icon
								size={20}
								name='arrows-rotate'
								color={Colors.red}
								onClick={() =>
									updateStatus(todo._id, TODO_STATUSES[status]?.previous)
								}
							/>
						)}
						<Icon
							size={20}
							name='eye'
							color={Colors.darkPurple}
							onClick={() => setIsTodoPreviewOpen(true)}
						/>
						{TODO_STATUSES[status]?.next && (
							<Icon
								size={20}
								name='x'
								color={Colors.red}
								onClick={() => updateStatus(todo._id, TODO_STATUSES.DONE.value)}
							/>
						)}
					</TodoItemElement>
				</>
			)}
			{isTodoPreviewOpen &&
				createPortal(
					<TodoPreview
						loadData={loadData}
						setShow={setIsTodoPreviewOpen}
						todo={todo}
					/>,
					document.body,
				)}
		</TodoItem>
	);
};

export default TodoListItem;
